// src/firebase/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// Optional: import analytics only if you're using it
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCdY1DgCNp97156-fkXtee3C6xstwH87IU",
  authDomain: "accissi-e4059.firebaseapp.com",
  projectId: "accissi-e4059",
  storageBucket: "accissi-e4059.appspot.com", // 🔧 fixed `.app` to `.appspot.com`
  messagingSenderId: "1073734594293",
  appId: "1:1073734594293:web:dc60fdfed90e0dcdae9fbc",
  measurementId: "G-26SH0EMB24"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Optional: initialize analytics (only in browser)
// const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

// Export services
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };


// src/firebase/firebase.js
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
//   authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
//   projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
//   storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
//   appId: import.meta.env.VITE_FIREBASE_APP_ID,
//   measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
// };

// const app = initializeApp(firebaseConfig);
// const db = getFirestore(app);
// const auth = getAuth(app);

// export { db, auth };
